export const PauseCircle = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      <path
        fill='#fff'
        fillOpacity={0.16}
        d='M12 24C5.373 24 0 18.627 0 12 0 5.372 5.373 0 12 0s12 5.372 12 12c0 6.627-5.373 12-12 12Zm0-21.96C6.5 2.04 2.04 6.5 2.04 12c0 5.5 4.46 9.96 9.96 9.96 5.5 0 9.96-4.46 9.96-9.96 0-5.5-4.46-9.96-9.96-9.96Z'
      />
      <mask
        id='a'
        width={13}
        height={24}
        x={11}
        y={0}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill='#D9D9D9' d='M11.999 0h12v24h-12z' />
      </mask>
      <g mask='url(#a)'>
        <path
          fill='var(--accent-primary)'
          d='M12 0a12 12 0 1 1 0 24v-2.04a9.959 9.959 0 0 0 7.043-17.003A9.96 9.96 0 0 0 12 2.04V0Z'
        />
      </g>
      <path
        stroke='var(--accent-primary)'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M10 15V9M14 15V9'
      />
    </svg>
  )
}
